import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { ComponentsModule } from '../components/components.module';
import { AppRoutingModule } from '../app-routing.module';

import { QuizListComponent } from './quiz-list/quiz-list.component';
import { QuizFormComponent } from './quiz-form/quiz-form.component';

import { QuizViewComponent } from './quiz-view/quiz-view.component';
import { QuizRespondComponent } from './quiz-respond/quiz-respond.component';
import { QuizReviewComponent } from './quiz-review/quiz-review.component';

@NgModule({
  declarations: [
    QuizListComponent,
    QuizFormComponent,
    QuizViewComponent,
    QuizRespondComponent,
    QuizReviewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    ComponentsModule,
    AppRoutingModule
  ]
})
export class QuizModule { }
